import Layout from "../../components/layout";
import { t } from "../../locales";
import DailyUsageModules from "../../components/dashboard/DailyUsageModules";
import StockManagementModules from "../../components/dashboard/StockManagementModules";
import MasterModules from "../../components/dashboard/MasterModules";

const DashboardPage = () => {
  return (
    <Layout>
      <div className="p-4 md:p-6 space-y-6 md:space-y-8">
        <h1 className="text-xl md:text-2xl font-semibold text-[#113F67]">
          {t.dashboard.pageTitle}
        </h1>
        <DailyUsageModules />
        <StockManagementModules />
        <MasterModules />
      </div>
    </Layout>
  );
};

export default DashboardPage;
